import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaSchool, FaUsersCog } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';


import co1 from '../assets/services/Re/1.jpg';
import co2 from '../assets/services/Re/2.jpg';
import co3 from '../assets/services/Re/3.jpg';
import co4 from '../assets/services/Re/4.png';

import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";
import HorizontalImageStrip from "../ones/HorizontalImagesStrip";
import { FaComputer } from "react-icons/fa6";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<>
				<div className="MainBodySection">
					<div
						style={{
							width: "100%",
							height: "auto",
							position: "relative",
							overflow: "hidden"
						}}
					>
						{banners.map((banner, i) => (
							<div
								key={i}
								style={{
									backgroundImage: `url(${banner})`,
									backgroundAttachment: "fixed",
									backgroundSize: "cover",
									backgroundPosition: "center",
									width: "100%",
									height: "100%",
									position: "absolute",
									top: 0,
									left: 0,
									transition: "opacity 1.5s ease-in-out",
									opacity: i === bgIndex ? 1 : 0,
								}}
							/>
						))}
	
						{/* gradient overlay */}
						<div
							style={{
								width: "100%",
								height: "100%",
								background: "linear-gradient(to right, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 80%, rgba(0,0,0,0) 100%)",
								position: "relative",
								zIndex: 1
							}}
						>
							<div className="container">
								<div className="row">
									<div className="col-md-6">

										<h1
											className="font-bold text-light"
											style={{
												fontSize: "28px",
												paddingTop: "40px",
												paddingBottom: "40px",
											}}
										>
											Business Process Re-engineering
										</h1>
	
									</div>
								</div>
							</div>
						</div>
	
					</div>
				</div>
				
				<div 
					className="MainBodySection"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row">

							<div className="col-md-12">

								<HorizontalImageStrip
									images={[co1, co2, co3, co4]}
								/>

							</div>

							<div className="col-md-12 mt-3">
								<h5>
									We analyse current organisational processes and design improved workflows that enhance performance. <br/><br/>
									We work with clients to map their “as-is” and “to-be” processes for clarity and implementation.
								</h5>								
							</div>

							<div className="col-md-12 my-5">
								<h2 className="fw-bold text-dark text-center mb-4">What We Do</h2>
								<p className="text-muted text-center mb-5" style={{ fontSize: '1.1rem' }}>
									We help organisations streamline operations—identifying bottlenecks, optimizing workflows, and laying the groundwork for smarter, more efficient service delivery.
								</p>

								<div className="row g-4">
									{/* Activities */}
									<div className="col-md-6">
									<div className="p-4 bg-light rounded-3 h-100">
										<h5 className="fw-bold text-primary mb-3">Activities</h5>
										<ul className="list-unstyled">
										<li className="mb-2 d-flex align-items-start">
											<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
											<span>Process mapping</span>
										</li>
										<li className="mb-2 d-flex align-items-start">
											<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
											<span>Efficiency analysis</span>
										</li>
										<li className="mb-2 d-flex align-items-start">
											<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
											<span>Redesign of workflows</span>
										</li>
										<li className="d-flex align-items-start">
											<span className="me-2 text-primary" style={{ marginTop: '0.25rem' }}>✓</span>
											<span>Identification of automated controls</span>
										</li>
										</ul>
									</div>
									</div>

									{/* Outputs / Deliverables */}
									<div className="col-md-6">
									<div className="p-4 bg-light rounded-3 h-100">
										<h5 className="fw-bold text-success mb-3">Deliverables</h5>
										<ul className="list-unstyled">
										<li className="mb-2 d-flex align-items-start">
											<span className="me-2 text-success" style={{ marginTop: '0.25rem' }}>✓</span>
											<span>Process maps</span>
										</li>
										<li className="mb-2 d-flex align-items-start">
											<span className="me-2 text-success" style={{ marginTop: '0.25rem' }}>✓</span>
											<span>Workflow documentation</span>
										</li>
										<li className="d-flex align-items-start">
											<span className="me-2 text-success" style={{ marginTop: '0.25rem' }}>✓</span>
											<span>Improvement recommendations</span>
										</li>
										</ul>
									</div>
									</div>
								</div>
								</div>

						</div>
					</div>
				</div>

				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}